import { render } from "./FormElement.vue?vue&type=template&id=74f8959a&ts=true"
import script from "./FormElement.vue?vue&type=script&lang=ts"
export * from "./FormElement.vue?vue&type=script&lang=ts"

import "./FormElement.vue?vue&type=style&index=0&id=74f8959a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__